import { friendlyApiErrorMessage } from 'src/app/services/api-error-notifier.service';
import { inject, Component, ElementRef, EventEmitter, HostBinding, HostListener, Input, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { FilterService } from 'src/app/services/filter.service';
import { LicenseManager } from  'ag-grid-enterprise'
LicenseManager.setLicenseKey("Using_this_AG_Grid_Enterprise_key_( AG-043433 )_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_( legal@ag-grid.com )___For_help_with_changing_this_key_please_contact_( info@ag-grid.com )___( Data Unveil )_is_granted_a_( Single Application )_Developer_License_for_the_application_( SCRAII )_only_for_( 1 )_Front-End_JavaScript_developer___All_Front-End_JavaScript_developers_working_on_( SCRAII )_need_to_be_licensed___( SCRAII )_has_been_granted_a_Deployment_License_Add-on_for_( 1 )_Production_Environment___This_key_works_with_AG_Grid_Enterprise_versions_released_before_( 7 June 2024 )____[v2]_MTcxNzcxNDgwMDAwMA==8211f96f946c59b6a3dfa3ea03a04f25")
import {
  ColDef,
  GridApi,
  GridReadyEvent,
  IServerSideDatasource,
  RowNode,
} from "ag-grid-community";
import { catchError, of, Subscription } from "rxjs";
import { DataService } from 'src/app/services/data.service';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { ApiService } from 'src/app/services/api.service';
import { ActivatedRoute } from '@angular/router';
import { NavigationService } from 'src/app/services/navigation.service';
import { NoDataNotifierService } from 'src/app/services/no-data-notifier.service';

@Component({
    selector: "app-data-grid",
    templateUrl: "./data-grid.component.html",
    styleUrls: ["./data-grid.component.scss"],
    standalone: false
})
export class WidgetDataGridComponent implements OnInit, OnDestroy {
  private readonly noDataNotifier = inject(NoDataNotifierService);
  static key = 100501;

  @Input("item") item: any = {};
  @Input("pageKey") pageKey: any;
  @Output("onSizeChange") onSizeChange = new EventEmitter<any>();
  @ViewChild("dataGridDiv", { static: true }) dataGridDiv!: ElementRef;
  @ViewChild('fs') fs!: ElementRef;
  @HostBinding('class.is-fullscreen') isFullscreen = false;
  isActive = false;
  isDataLoaded = false;
  agGridShowStatus = false;
  loader:Boolean=true
  error_name:any;
  menuTabs:any = ["columnsMenuTab", "filterMenuTab"];
  data: any[] = [];
  config: any = {};
  heading = "Processing Status";
  rowStyle: any;
  rowHeight: any;
  private gridApi!: GridApi;
  columnDefs: ColDef[] = [];
  dataRange: any[] = [];
  prefix = "";
  suffix = "";
  autoGroupColumnDef: ColDef<any> = {};
  dataAlignment: any;
  reqSubcription: Subscription[] = [];
  expandCollapseIcon:any = "expand";
  expandOrCollapse = "Expand All";
  noData: Boolean = false
  public defaultColDef: ColDef<any> = {
    flex: 1,
    minWidth: 120,
    resizable: true,
    sortable: false,
    suppressMenu: true
  };
  orderbyData:any = {};
  dashboardKey:any;
  treeOrderType:any;

  constructor(
    private filterService: FilterService, 
    private dataService: DataService, 
    private httpClient: HttpClient, 
    private apiService: ApiService,
    private route: ActivatedRoute,
    private navigationService: NavigationService
  ) {
    this.route.params.subscribe((p: any) => {
      this.route.queryParams.subscribe((params: any) => {
        let decryptedParams = this.navigationService.decryptData(params);
        this.dashboardKey = decryptedParams["ds_key"];
      });
    });

    this.reqSubcription.push(
      this.filterService.filterQuery.subscribe((query: any) => {
        this.loadDataGridConfig()
        // this.loadApiData();
        this.loadOrder();
        this.loader=true
      })

      );
    // this.dataService.expandCollapseChart.subscribe((res:any) => {
    //   // this.expandCollapse()
    // })
    
    this.rowHeight = 0;
    this.rowStyle = {
      padding: "0px 0px",
      "border-bottom": "#f3f3f3 1px solid",
    };
  }

  @HostListener('fullscreenchange')
  @HostListener('webkitfullscreenchange')
  @HostListener('mozfullscreenchange')
  @HostListener('MSFullscreenChange')
  screenChange () {
    this.isFullscreen = !!document.fullscreenElement
  }

  ngOnInit(): void {
    const observer = new ResizeObserver((e: any) => {
      this.onSizeChange.emit(e[0].contentRect.height);
    });
    observer.observe(this.dataGridDiv.nativeElement);
    this.loadDataGridConfig();
    this.loadDataNewGridConfig();
 this.expandCollapseIcon = "expand";

  }

  ngOnDestroy(): void {
    this.reqSubcription.forEach((res) => res.unsubscribe());
  }

  ngOnChanges(changes: any): void {}

  onGridReady(params: GridReadyEvent) {
    this.gridApi = params.api;
    this.gridApi.addEventListener('rowGroupOpened', this.onRowGroupOpened.bind(this));
  }

  onRowGroupOpened(event: any): void {
    // Check if all autoGroupColumnDef groups are closed
    let allGroupsClosed = false;
    
    this.gridApi.forEachNode((node) => {
      if (node.group && node.expanded) {
        allGroupsClosed = true;
      }
    });

    if(allGroupsClosed) {
      this.expandCollapseIcon = "collapse";
      this.expandOrCollapse = "Collapse All";
    } else {
      this.expandCollapseIcon = "expand";
      this.expandOrCollapse = "Expand All";
    }

    this.filterService.expendTree.next({'key':WidgetDataGridComponent.key,'value':allGroupsClosed})
  }

  // expendCol(event:any) {
  //   if(event) {
  //     this.expandCollapseIcon = "collapse";
  //     this.expandOrCollapse = "Collapse All";
  //     this.gridApi?.expandAll();
  //   } else {
  //     this.expandCollapseIcon = "expand";
  //     this.expandOrCollapse = "Expand All";
  //     this.gridApi?.collapseAll();
  //   }
  // }

  expendCol(expand: boolean) {
    if (!this.gridApi) return;

    if (expand) {
      this.expandCollapseIcon = 'collapse';
      this.expandOrCollapse = 'Collapse All';

      this.gridApi.forEachNode(node => {
        if (!node.group || !node.allLeafChildren?.length) return;

        const firstLeaf = node.allLeafChildren[0]?.data;

        // -------- Rule 2: Compute real depth from data --------
        const hierarchy = this.config.levels
      .map((field:any) => firstLeaf[field])
      .filter((v:any) => v !== null && v !== undefined && v !== '');

        const maxDepthForRow = hierarchy.length;  // real depth (3–5)
        const currentDepth = node.level ?? 0;     // root=0, SP=1, Commercial=2...

        const depthAllowed = currentDepth < maxDepthForRow - 1;

        // -------- Rule 3: Must have children --------
        const hasChildren = (node.childrenAfterGroup?.length ?? 0) > 0;

        const allowed =  depthAllowed && hasChildren;

        node.setExpanded(allowed);
      });

      // 🔁 re-evaluate rowClassRules & icon hiding
      this.gridApi.redrawRows();

    } else {
      this.expandCollapseIcon = 'expand';
      this.expandOrCollapse = 'Expand All';

      this.gridApi.collapseAll();
      this.gridApi.redrawRows();
    }
  }

  loadDataGridConfig() {
      this.data = [];
      let cfg = this.item.config;
      this.config["heading"] = cfg["report_heading"] || "Data Grid";
      this.treeOrderType = cfg?.["tree_order_type"] || null;

      if (cfg["status_column"]) {
        this.config.status_column = cfg["status_column"]["api_resp_column_nm"];
        this.config.levels = [];
        for (let i = 1; i < 10; i++) {
          const element = cfg?.['l' + i + '_col']?.['api_resp_column_nm'];
          if (element != undefined) {
            this.config.levels.push(element);
          }
        }
      }
    }

loadDataNewGridConfig() {
    this.data = [];
    let cfg = this.item.config;
    this.heading = cfg["report_heading"] || "Data Grid";
    this.dataRange = cfg["status_color_code"] ? cfg["status_color_code"].data : [];
    this.prefix = cfg["status_color_code"].prefix || "";
    this.suffix = cfg["status_color_code"].suffix || "";
    this.dataAlignment = cfg["data_alignment"]?.["value"]?.toLowerCase() || "center";

    // 1. Initialize Column Definitions with the Status Column
    const newColumnDefs: ColDef[] = [
      {
        field: cfg.status_column["api_resp_column_nm"],
        headerName: cfg.status_column["api_resp_column_display_nm"],
        aggFunc: "avg",
        menuTabs: this.menuTabs,
        suppressMenu: true,
        filter: "agNumberColumnFilter",
        valueFormatter: (params) =>
          this.prefix + parseFloat(params.value + "").toFixed(2) + this.suffix,
        cellStyle: (param) => {
          return {
            "text-align": this.dataAlignment,
            color: this.getDataColor(this.dataRange, param),
            "font-size": "13px",
          };
        },
        cellRendererParams: { config: cfg },
      },
    ];

    // 2. Add Row Group levels (only from the filtered this.config.levels)
    this.config.levels.forEach((groupColDef: any, index: number) => {
      // If we have multiple levels, the last one usually acts as the leaf node in the autoGroup
      if (this.config.levels.length > 1 && index === this.config.levels.length - 1) {
        return;
      }
      newColumnDefs.push({
        field: groupColDef,
        rowGroup: true,
        hide: true,
        suppressColumnsToolPanel: true,
      });
    });

    // 3. Add Extra Columns (heading_colors)
    cfg["heading_colors"].forEach((col: any) => {
      if (col["isSelected"]) {
        let coldef: any = {
          sortable: true,
          resizable: true,
          menuTabs: this.menuTabs,
          suppressMenu: true,
          filter: "agNumberColumnFilter",
          field: col["api_resp_column_nm"] == "delay" ? "delayed" : col["api_resp_column_nm"],
          cellStyle: { "text-align": this.dataAlignment, "font-size": "13px" },
          type: "numericColumn",
          aggFunc: "sum",
          headerName: col['api_resp_column_display_nm']
        };

        if (col['isColumnColorSelected']) {
          coldef['cellStyle'] = (param: any) => {
            return { "text-align": this.dataAlignment, "font-size": "13px", color: param.value != 0 ? col['columnColor'] : '#000' };
          };
        }

        if(col['isHeaderSelected']!=false) {
          coldef['headerComponentParams'] = {
            template: `
                  <div class="ag-cell-label-container" role="presentation">
                    <div ref="eLabel" class="ag-header-cell-label" role="presentation">
                        <span ref="eSortOrder" class="ag-header-icon ag-sort-order" ></span>
                        <span ref="eSortAsc" class="ag-header-icon ag-sort-ascending-icon" ></span>
                        <span ref="eSortDesc" class="ag-header-icon ag-sort-descending-icon" ></span>
                        <span ref="eSortNone" class="ag-header-icon ag-sort-none-icon" ></span>
                        <span class="ag-header-cell-text">
                        <i style="font-size: 9px;color:${col['color']};padding-right:5px;" class="fa fa-circle"></i>
                        ${col["api_resp_column_display_nm"]}
                        </span>
                        <span ref="eFilter" class="ag-header-icon ag-filter-icon"></span>
                    </div>
                    <span ref="eMenu" class="ag-header-icon ag-header-cell-menu-button"></span>
                  </div>
                `,
          }
        }
        newColumnDefs.push(coldef);
      }
    });

    this.columnDefs = newColumnDefs;

    // 4. Update Auto Group Column
    this.autoGroupColumnDef = {
      flex: 1,
      minWidth: 400,
      headerName: cfg.l1_col["api_resp_column_display_nm"],
      // Set leaf field to the last available level
      field: this.config.levels.length === 0 ? undefined : this.config.levels[this.config.levels.length - 1],
      cellRendererParams: { suppressCount: true },
      sortable: false,
      resizable: false,
      cellClassRules: { 'autoGroupClass': params => params.node.level === 0 },
      // menuTabs: this.menuTabs,
      // filter: "agNumberColumnFilter",
      // suppressMenu: true,
      // sort: 'asc'
    };
  }

  // getValue(prefix:any,param:any,suffix:any) {
  //     return prefix + ' ' + parseFloat(param).toFixed(2) + suffix
  // }

  getDataColor(rangeValue: any, param: any) {
    if (!rangeValue) return null;

    for (let idx in rangeValue) {
      let r = rangeValue[idx];
      if (
        (parseInt(r.startValue) <= param.value ||
          parseInt(r.startValue) <= param.value.value) &&
        (param.value.value <= parseInt(r.endValue) ||
          param.value <= parseInt(r.endValue))
      ) {
        return r.color;
      }
    }
    return null;
  }

  loadApiData() {
      let api = this.item.config["list_of_api"] || {};
      this.isDataLoaded = false;

      if (api.api_key && !this.filterService.isEmptyObject(this.filterService.baseQuery)) {
        let obj: any = { "api_key": api.api_key };
        let query = Object.assign({}, this.filterService.baseQuery, obj);
        query["report_typ"] = this.filterService.report_type;
        query['module_key'] = this.apiService.getModuleKey();

        let endpoint = this.item.config?.['list_of_api_endpoint'] || '';

        this.reqSubcription.push(
          this.httpClient.post(`${this.apiService.apiBaseUrl}/${endpoint || this.apiService.executionUrl}`, query).subscribe((res: any) => {
            this.loader = false;
            this.isDataLoaded = true;
            const apiData = res || [];

            // --- STEP 1: Filter out levels that have NO data in the response ---
            if (apiData.length > 0) {
              this.config.levels = this.config.levels.filter((levelField: any) =>
                apiData.some((row: any) => row[levelField] !== null && row[levelField] !== undefined && String(row[levelField]).trim() !== '')
              );
            }

            // --- STEP 2: Re-run config to update Column Definitions ---
            this.loadDataNewGridConfig();

            // --- STEP 3: Assign the data ---
            this.noData = apiData.length === 0;
            if (this.treeOrderType) {
              this.data = this.sortDataByOrderByConfig(apiData, this.orderbyData);
            } else {
              this.data = apiData;
            }
            this.error_name = '';
          }, (err: any) => {
            console.log('grid',err)
            this.isDataLoaded = true;
            this.noData = true; this.noDataNotifier.report('data-grid');
            this.data = [];
            this.loader = false;
            this.error_name = friendlyApiErrorMessage(err);
          })
        );
      }
    }

  fullscreenChanges(fullscreen:any){
    this.isFullscreen = fullscreen;
    this.isActive = fullscreen;
  }

  // Grid options for ag-Grid
  gridOptions: any = {
    groupDefaultExpanded: 0,
    suppressDoubleClickExpand: true,
    rowClassRules: {
      'no-expand': (params: any) => {
        const node = params.node;
        if (!node.group || !node.allLeafChildren?.length) return false;

        const firstLeaf = node.allLeafChildren[0]?.data;

        // -------- Rule 1: Business rule --------
        // const sourceSubAllowed = firstLeaf?.source_sub_name == null;

        // -------- Rule 2: Compute real depth from data --------
        const hierarchy = this.config.levels
        .map((field:any) => firstLeaf[field])
        .filter((v:any) => v !== null && v !== undefined && v !== '');

        const maxDepthForRow = hierarchy.length;   // real depth (3–5)
        const currentDepth = node.level ?? 0;      // root=0, SP=1, Commercial=2...

        const depthAllowed = currentDepth < maxDepthForRow - 1;

        // -------- Rule 3: Must have children --------
        const hasChildren = (node.childrenAfterGroup?.length ?? 0) > 0;

        const allowed =  depthAllowed && hasChildren;

        // If NOT allowed → apply no-expand class
        return !allowed;
      }
    },
    onRowGroupOpened: (event:any) => {
      this.enforceExpansionRules(event.node);
    },
    getContextMenuItems: (params:any) => {
      return [
        'copy', // Default copy options
        'copyWithHeaders', // Default copy with headers option
        'copyWithGroupHeaders', // Default copy with group headers option
        'paste', // Default paste option
        {
          name: 'Export to Excel',
          action: () => this.exportXls(),
        },
      ];
    },
  };
  
  enforceExpansionRules(node: RowNode): void {
    if (!node.group || !node.allLeafChildren?.length) return;

    const firstLeaf = node.allLeafChildren[0]?.data;

    // -------- Rule 1: Your business rule --------
    // const sourceSubAllowed = firstLeaf?.source_sub_name == null;

    // -------- Rule 2: Compute real hierarchy depth --------
    const hierarchy = this.config.levels
      .map((field:any) => firstLeaf[field])
      .filter((v:any) => v !== null && v !== undefined && v !== '');
    // remove null / undefined levels

    const maxDepthForRow = hierarchy.length;   // actual depth (3–5)
    const currentDepth = node.level ?? 0;      // root=0, SP=1, Commercial=2...

    const depthAllowed = currentDepth < maxDepthForRow - 1;

    // -------- Rule 3: Must have real children --------
    const hasChildren = (node.childrenAfterGroup?.length ?? 0) > 0;

    const allowed = depthAllowed && hasChildren;

    if (!allowed && node.expanded) {
      node.setExpanded(false);
    }
  }

  exportXls() {
    this.gridApi.exportDataAsExcel({
      fileName: this.item.config['report_heading'],
      sheetName: this.filterService.selectedBrandName || this.item.config['report_heading'],
      processCellCallback: (params: any) => {

        let enhancement = params.column.colDef?.cellRendererParams
        let prefix = enhancement?.config?.['status_color_code'].prefix
        let suffix = enhancement?.config?.['status_color_code'].suffix

        return (prefix ? prefix : '')  + params.value + (suffix ? suffix : '');
      }
    });
  }

  loadOrder () {
    if(this.treeOrderType) {
      let obj = { api_key: '100280' }
      let query = Object.assign({}, this.filterService.baseQuery, obj)
      query['report_typ'] = this.filterService.report_type;
      query['comment_typ'] = this.treeOrderType
  
      this.httpClient.post(`${ this.apiService.apiBaseUrl }/${ this.apiService.executionUrl }`, query)
        .pipe(catchError(e => of([])))
        .subscribe((res: any) => {
          // if (!res.length) return
          this.orderbyData = res[0]
          this.loadApiData();
        })
    } else {
      this.loadApiData();
    }
  }
  
  sortDataByOrderByConfig(data: any[], orderbyData: any) {
    if (!Array.isArray(data) || !this.config?.levels?.length) {
      return data;
    }

    const levels = this.config.levels;
    const orderMaps = this.buildOrderMaps(orderbyData, levels);

    return data.sort((a: any, b: any) => {
      for (let i = 0; i < levels.length; i++) {
        const field = levels[i];

        const valA = this.normalize(a[field]);
        const valB = this.normalize(b[field]);

        const map = orderMaps[i];

        const hasA = map?.has(valA);
        const hasB = map?.has(valB);

        // business order ONLY when one/both are defined
        if (hasA || hasB) {
          const orderA = hasA ? map!.get(valA)! : Number.MAX_SAFE_INTEGER;
          const orderB = hasB ? map!.get(valB)! : Number.MAX_SAFE_INTEGER;

          if (orderA !== orderB) {
            return orderA - orderB;
          }
        }

        // alphabetical fallback ONLY if both are unordered
        if (!hasA && !hasB) {
          if (valA > valB) return 1;
          if (valA < valB) return -1;
        }
      }

      return 0;
    });
  }

  buildOrderMaps(orderbyData: any, levels: string[]): Map<string, number>[] {
    const maps: Map<string, number>[] = [];

    levels.forEach((_, index) => {
      const orderKey = `level_${index + 1}`;
      const value = orderbyData?.[orderKey];

      if (!value) {
        maps[index] = new Map();
        return;
      }

      if (typeof value === 'string' && value.includes(',')) {
        maps[index] = new Map(
          value
            .split(',')
            .map((v: string, i: number) => [this.normalize(v), i])
        );
      } else {
        maps[index] = new Map([[this.normalize(value), 0]]);
      }
    });

    return maps;
  }
  
  private normalize(val: any): string {
    return (val ?? '').toString().trim().toLowerCase();
  }

}
